module.exports = __webpack_public_path__ + "img/Menu-Get_14.b3a7d138.png";